import React from 'react'
import {Link} from 'gatsby'
import logo from "../../assets/images/logo-domain1.svg"
import footerMap from "../../assets/images/footer-map.png"

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area bg-color">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget align-items-center">
                            <a href="/" className="logo">
                                <img src={logo} alt="logo" />
                            </a>
                            <p>Differentech</p>

                            <ul className="social-link">
                                <li>
                                    <Link to="https://twitter.com/domainmexico" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-twitter'></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.linkedin.com/company/do-main" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-linkedin'></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Explora</h3>
                            
                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>
                                    <li>
                                    <Link to="/about-us">
                                        Acerca de
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/case-studies">
                                        Casos de Estudio
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog">
                                        Blog
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact">
                                        Cont&aacute;ctanos
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Recursos</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/team">
                                        Nuestro Equipo
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/services">
                                        Servicios
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/testimonials">
                                        Testimoniales
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/services">
                                        Servicios
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Domicilio</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i> 
                                    Prolongaci&oacute;n Vasco de Quiroga #3735, Cuajimalpa, CDMX<br /> M&eacute;xico
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:+44587154756">+52 (155) 5252 3629</a>
                                </li>
                                <li>
                                    <i className='bx bx-envelope'></i>
                                    <a href="mailto:hello@rewy.com">contacto@domainmx.mx</a>
                                </li>
                                <li>
                                    <i className='bx bxs-inbox'></i>
                                    <a href="tel:+557854578964">55 5252 3629</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p>Copyright @{currentYear} <strong>do&#123;main&#125;</strong> Todos los derechos reservados</p>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <ul>
                                <li>
                                    <Link to="/privacy-policy">
                                        Aviso de Privacidad
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/politica-cookies">
                                        Política de Cookies
                                    </Link>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <a href="https://storyset.com/people">People illustrations by Storyset</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-map">
                <img src={footerMap} alt="footer-logo" />
            </div>
        </footer>
    );
}

export default Footer;